import { Layout } from '@/components/layout';
import { PreAuthOutlet } from '@/outlets/pre-auth-outlet';
import { VerifyIdentityPage } from '@/pages/auth/verify-identity/verify-identity-page';
import { Route } from '@/util/react-router-dom';

export const preAuthRoutes = (
  <Route element={<PreAuthOutlet />}>
    <Route element={<Layout />}>
      <Route path="verify-identity" element={<VerifyIdentityPage />} />
    </Route>
  </Route>
);
